import Vue from "vue";
import Vuex from "vuex";
import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";
import navigation from "./modules/navigation";
import swatch from "./modules/swatch";

Vue.use(Vuex);

export const store = new Vuex.Store(
   {
      state: {
         AppName: '',
         AgencyLogo: '',
         AgencyIcon: 'favicon.ico',
         num_coachups: null,
      },
      getters,
      mutations: {
         setAppName(state, val){
            state.AppName = val;
         },
         setAgencyLogo(state, val){
            state.AgencyLogo = val;
         },
         setAgencyIcon(state, val){
            state.AgencyIcon = val;
         }
      },
      actions,
      modules: {
         navigation,
         swatch
      }
  }
);
